import type { CuratedListPageName } from '../Sections/CuratedListsSection';
import type { CuratedList } from '~~/core/entities/CuratedList';
import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as CuratedListCard } from './ListCard.vue';

type CuratedListCardVariant = 'default' | 'rich-content';

export interface CuratedListCardProps {
	curatedList: CuratedList;
	pageName?: CuratedListPageName;
	detailsUrl: string;
	variant?: CuratedListCardVariant;
	class?: HTMLAttributes['class'];
}

export const cardRootVariants = cva(
	'group/card flex h-full cursor-pointer flex-col justify-start bg-secondary p-6 transition-colors duration-300 hover:bg-secondary-dark-1',
	{
		variants: {
			variant: {
				default: 'md:px-8 md:py-15 md:pb-8',
				'rich-content': 'md:p-6 lg:px-8 lg:py-13 lg:pb-8'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

export const cardContentVariants = cva('flex flex-col px-0', {
	variants: {
		variant: {
			default: 'gap-2 pt-6 md:max-w-[80%] md:gap-6',
			'rich-content': 'gap-2 pb-4 pt-6 md:gap-6'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});

export const creatorInfoWrapperVariants = cva('', {
	variants: {
		variant: {
			default:
				'flex w-full flex-col gap-2 md:flex-row md:items-center md:gap-3',
			'rich-content': 'flex flex-col gap-2 lg:flex-row lg:items-center lg:gap-3'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});

export const creatorAvatarVariants = cva('size-12 md:size-11', {
	variants: {
		variant: {
			default: 'size-12 md:size-11',
			'rich-content': 'size-12'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});

export const mainContentTextVariants = cva(
	'font-sans font-normal leading-normal text-primary',
	{
		variants: {
			variant: {
				default: 'text-sm md:text-lg md:leading-normal',
				'rich-content': 'text-base md:text-lg md:leading-normal'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

export const footerVariants = cva('mt-auto flex size-full h-fit p-0', {
	variants: {
		variant: {
			default: 'items-end justify-end',
			'rich-content': 'items-center justify-between'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});
